export default "__VITE_ASSET__BMzEr0gu__"